import PaymentMethodsInfo from 'components/Content/Happening/ReservationDetails/PaymentMethodsInfo/PaymentMethodsInfo';

export default PaymentMethodsInfo;
